export const ru = {
    'add-payer': 'добавить плательщика',
    'no-payers':
        'Для вашего аккаунта не указан плательщик, поэтому настроить порог отключения невозможно. Вы можете {addPayerLink} и настроить порог отключения',
    'no-payment-methods':
        'Для всех плательщиков, связанных с вашим аккаунтом, недоступна оплата рекламы, поэтому настроить порог отключения невозможно. Чтобы решить проблему, {writeToUsLink}.',
    'try-later': 'Что-то пошло не так. Попробуйте еще раз.',
    'write-to-us': 'напишите нам'
};
